import React from "react";
import "./RoadTransport.css";
import Open from "./Open";
import InProgress from "./InProgress";
import Closed from "./Closed";
import Draft from "./Draft";

const RoadTransport = ({ value }) => {
  return (
    <>
      {value === 0 && <Draft />}
      {value === 1 && <Open />}
      {value === 2 && <InProgress />}
      {value === 3 && <Closed />}
    </>
  );
};

export default RoadTransport;
